import type { PcmpProposalStudentClass, PcmpTimelineNode } from '../../types/pcmpProposal.types';
import { PcmpTimelineNodeCard } from './PcmpTimelineNodeCard';

interface PcmpTimelineTrackProps {
  title: string;
  nodes: PcmpTimelineNode[];
  students: PcmpProposalStudentClass[];
}

export function PcmpTimelineTrack({ title, nodes, students }: PcmpTimelineTrackProps) {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-sm font-semibold">{title}</h3>
      <div className="flex flex-col gap-3 lg:flex-row lg:overflow-x-auto lg:pb-2">
        {nodes.map((node, index) => (
          <PcmpTimelineNodeCard
            key={`${node.kind}-${node.level ?? index}-${node.userId ?? index}`}
            node={node}
            students={students}
          />
        ))}
      </div>
    </div>
  );
}
